import { Form } from 'antd';
import { useTranslation } from 'react-i18next';

import { Input } from 'components';

import useValidation from 'hooks/forms/useValidation';

import { ITotpStepProps } from './TotpStep.types';

const TotpStep = ({ loading }: ITotpStepProps) => {
  const { t } = useTranslation();
  const rule = useValidation();

  return (
    <>
      <Form.Item name="totp" label={t('form.label.totp')} rules={rule.ga} validateFirst>
        <Input.Password autoFocus disabled={loading} />
      </Form.Item>
    </>
  );
};

export default TotpStep;
